import { createFileRoute, notFound } from "@tanstack/react-router";
import { getPage } from "@/content/pages";
import { MarkdownPage } from "@/components/MarkdownPage";
import ServiceAppImage from "@/assets/service-app.jpg";
import { pageMetaTitle, metaDescription } from "@/lib/seo";

const PAGE_KEY = "/bespoke-app-development";

export const Route = createFileRoute("/bespoke-app-development")({
  loader: () => {
    const page = getPage(PAGE_KEY);
    if (!page) throw notFound();
    return page;
  },
  head: ({ loaderData }) => ({
    meta: loaderData
      ? [
          { title: pageMetaTitle(PAGE_KEY, loaderData.title) },
          { name: "description", content: metaDescription(loaderData.description) },
          { property: "og:title", content: pageMetaTitle(PAGE_KEY, loaderData.title) },
          { property: "og:description", content: metaDescription(loaderData.description) },
          { property: "og:url", content: "https://www.phil-carr.co.uk/bespoke-app-development" },
        ]
      : [],
    links: [{ rel: "canonical", href: "https://www.phil-carr.co.uk/bespoke-app-development" }],
  }),
  notFoundComponent: () => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-4xl">Page not found</h1>
    </div>
  ),
  errorComponent: ({ error }) => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-3xl">Something went wrong</h1>
      <p className="mt-3 text-muted-foreground">{error.message}</p>
    </div>
  ),
  component: Page,
});

function Page() {
  const page = Route.useLoaderData();
  return (
    <MarkdownPage
      body={page.body}
      pageContext={page.title}
      heroImage={{
        src: ServiceAppImage,
        alt: "Smartphone resting on a wooden desk beside a small plant",
      }}
      relatedSlugs={[
        "building-a-website-that-supports-seo-and-business-growth",
        "mobile-and-core-web-vitals-in-2023",
        "user-experience-takes-centre-stage-core-web-vitals-2-0-and-beyond",
      ]}
    />
  );
}
